<template>
  <v-container fluid>
    <v-card outlined>
      <v-card flat tile class="pa-3 v-card-border-bottom">
        <v-form v-model="valid" ref="form" @submit.prevent>
          <v-row class="d-flex align-center">
            <v-col>
              <v-text-field
                v-model="searchWord.userId"
                :label="$t(`loggingUserId`)"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="searchWord.deviceGroupName"
                :label="$t(`loggingDeviceGroup`)"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex align-center">
            <v-col>
              <Calendar
                v-model="searchWord.datetimeFrom"
                :label="$t('from')"
                :rules="[validator.isAfterDate(searchWord.datetimeTo)]"
                clearable
              />
            </v-col>
            <v-col>
              <Calendar
                v-model="searchWord.datetimeTo"
                :label="$t('to')"
                :rules="[validator.isBeforeDate(searchWord.datetimeFrom)]"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex align-center justify-center fill-height">
              <v-btn @click="download" color="primary" dark depressed>
                <custom-icon type="download" :size="15" :colors="['#FFFFFF']" class="mr-2"> </custom-icon>
                <v-icon>mdi-file-document-multiple-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Calendar from '../components/Calendar.vue';
  import validator from '@/utils/validator.js';
  import CustomIcon from '@/components/CustomIcon.vue';
  import csv from '@/utils/csv';
  import logging from '@/utils/logging';
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: { Calendar, CustomIcon },
    mixins: [validator, csv, logging],
    data: () => ({
      items: [],
      valid: true,
      searchWord: {
        userId: undefined,
        deviceGroupName: undefined,
        datetimeFrom: undefined,
        datetimeTo: undefined,
      },
    }),
    filters: {},
    computed: {
      ...mapGetters('auth', ['user_info']),
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
    },
    created() {},
    watch: {},
    methods: {
      async getLogs() {
        this.items = [];
        this.$store.commit('loading/start_loading');
        try {
          const result = await this.azureRequest('/api/getLogs', 'POST', {
            localeId: this.localeId,
            search: this.searchWord,
          });
          this.items = result;
        } catch (error) {
          console.error(error);
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },

      async reset() {
        this.$refs.form.reset();
      },
      async searchClicked() {
        console.log('サーチ');

        await this.getLogs();
      },
      async download() {
        await this.getLogs();
        const header = [];
        header.push(this.$t('loggingDateiime'));
        header.push(this.$t('loggingType'));
        header.push(this.$t('loggingUserId'));
        header.push(this.$t('loggingDeviceGroup'));

        header.push(...[...Array(10)].map((el, index) => `${this.$t('loggingFunc')}${index + 1}`));
        const dataList = this.items.map((el) => {
          return [
            this.$dayjs(el.datetime).format('YYYY/MM/DD hh:mm:ss:SSS'),
            el.type,
            el.userId,
            el.deviceGroup && el.deviceGroup[`device_group_name_locale${this.localeId}`]
              ? el.deviceGroup[`device_group_name_locale${this.localeId}`]
              : null,
            el.contents?.monthlyReport?.date ? this.$dayjs(el.contents?.monthlyReport?.date).format('YYYY/MM') : null,
            el.contents?.monthlyReport?.device?.serialNo,
            el.contents?.monthlyReport?.group?.groupName,
            el.contents?.monthlyReport?.allDevices &&
            el.contents.monthlyReport.allDevices[`device_group_name_locale${this.localeId}`]
              ? el.contents.monthlyReport.allDevices[`device_group_name_locale${this.localeId}`]
              : null,
          ];
        });

        const fileName = `${this.$dayjs().format('YYYYMMDD')}.csv`;
        this.downloadCsv(fileName, [header, ...dataList]);
      },
    },
  };
</script>
<style scoped></style>
